export default "__VITE_ASSET__DPYY3thB__"